import styled from 'styled-components';

import { TooltipContent, TooltipWrapper } from '@spa/shared/components/Tooltip/styles';
import { PRICE_LINE_TYPES } from '@spa/shared/constants/priceLine';

const { INCLUDED, DISCOUNT } = PRICE_LINE_TYPES;

export const Wrapper = styled.div`
  display: flex;
  ${({ theme }) => theme.gap(2)};
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.gap(1)}
`;

export const Text = styled.p`
  ${({ theme }) => theme.gap(1)}
  font-size: ${props => (props.bigger ? props.theme.rem(15) : props.theme.rem(14))};
  font-weight: ${props => (props.isTitle || props.bold ? 600 : 400)};
  line-height: ${props => props.theme.rem(18)};

  ${props =>
    [INCLUDED, DISCOUNT].includes(props.type) &&
    `
    color: ${props.theme.colors.emerald};
    font-weight: 600;
  `}
`;

export const IsIncludedText = styled(Text)`
  color: ${props => props.theme.colors.mountainMeadow};
`;

export const LeftTopLine = styled.div`
  display: flex;

  ${TooltipWrapper} {
    margin-left: ${props => props.theme.space(2)};

    ${TooltipContent} {
      ${Text} {
        color: white;
      }
    }
  }
`;
